// Shared types for transaction components

export interface Order {
  id: string;
  order_id: string; // Added to match ProductItem structure
  orderNumber: string;
  order_number: string; // Added to match ProductItem naming convention (snake_case)
  date: string;
  orderDate: string;
  amount: number;
  totalAmount: number;
  commission: number;
  sales: number;
  netEarnings: number;
  has_transaction_id?: boolean; // Flag indicating if order is linked to a transaction
  transaction_id?: string; // ID of linked transaction, if any
}

export interface ProductItem {
  id: string;
  order_id: string;
  order_number: string;
  product_name: string;
  sku: string;
  price: number;
  qty: number;
  total_price: number;
  total_tax: number;
  coupon_amount: number;
  shipping_amount: number;
  commission: number;
  subtotal: number;
  image: string;
}

export type ViewType = 'orders' | 'products';

export interface OrderTotals {
  total_amount: number;
  total_commission: number;
  total_transaction: number;
}

export interface TransactionDetailsProps {
  orders: Order[];
  products?: ProductItem[];
  productsLoading?: boolean;
  productsError?: any;
  transactionDate: string;
  transactionId: string;
  orderTotals?: OrderTotals;
}

// We're now importing FilterTabItem directly in components that need it

// Styling constants
export const STYLES = {
  dropdown: {
    button: {
      backgroundColor: 'transparent',
      border: '2px solid #ff7f00',
      color: '#ff7f00',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    menu: {
      padding: '12px',
      borderRadius: '10px',
      boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
      minWidth: '200px',
    }
  },
  productImage: {
    container: {
      width: '60px', 
      height: '60px', 
      flexShrink: 0 as const
    },
    wrapper: {
      width: '100%', 
      height: '100%', 
      overflow: 'hidden',
      borderRadius: '4px',
      border: '1px solid #dee2e6',
      backgroundColor: '#f8f9fa'
    },
    img: {
      maxWidth: '100%', 
      maxHeight: '100%', 
      objectFit: 'contain' as const
    },
    placeholder: {
      width: '100%', 
      height: '100%', 
      borderRadius: '4px',
      border: '1px solid #dee2e6'
    }
  },
  table: {
    props: {
      className: 'phoenix-table fs-9',
      striped: true,
      hover: true
    },
    loadingContainer: {
      height: '200px'
    }
  }
};
